import { Role } from "@/models/role/role.model"
import { type IRolePlanner } from "@/interfaces/api/role/role-planner.interface"
import { RoleTypes } from "@/enums/role-types"
import { Location } from "@/models/location.model"
import { ModelFactory } from "@/factories/model-factory"

export class RolePlanner extends Role implements IRolePlanner {
  public static className = "RolePlanner"
  public static verboseName = "Planner"

  defaultLocation: Location

  constructor(rolePlanner: IRolePlanner, managed = false) {
    super(rolePlanner)

    this.type = RoleTypes.PLANNER

    this.defaultLocation = ModelFactory.childModel(Location, rolePlanner.defaultLocation, managed)
  }
}
